export enum NavControllerDirection {
  ROOT = 'root',
  FORWARD = 'forward',
  BACK = 'back',
  AUTO = 'auto',
}
